export interface DivisorElementTitleProps {
  title?: string;
}

export default ({ title }: DivisorElementTitleProps) => {
  return (
    <p className="text-darkMode-gray-light/70 text-sm sm:text-[16.782px] tracking-[0.127px] mb-[-6px] leading-[normal]">{title}</p>
  );
};
